import { message } from "antd";
message.config({
  top: 50, // Position the message 100px from the top of the screen
  duration: 8, // Duration for which the message will be displayed
  maxCount: 1, // Limit the number of messages displayed at the same time
  rtl: true, // Right to Left text direction (for languages like Arabic)
  prefixCls: "my-message", // Custom CSS class for styling messages
});
//function to check success or error of Response data and display messages accordingly
export const responseMessage = (type: string, data: string = "") => {
  switch (type) {
    case "Successful":
      message.success(type); //success message
      break;
    case "Error":
      message.error(type); //error message
      break;
    case "ErrorCustom":
      message.error(data); //error message
      break;
    default:
      message.info(type);
      break;
  }
};
